import { formatISO } from 'date-fns';
import request from '../utils/request';
import { DictionaryDto, initDictItem, PagedView } from './dictionary';

export interface FlightDto {
    id: number | string;
    code: string;
    date_created?: Date;
    date_ended?: Date;
    state: string;
    courier: {
        first_name: string;
        last_name: string;
        phone_number: string;
        is_freelancer?: boolean;
    };
    creator: {
        first_name: string;
        last_name: string;
        username: string;
    };
    delivery_list_status: DictionaryDto;
    with_payment?: boolean;
}

export type FlightBody = {
    page: number;
    size: number;
    code: string | null;
    status: string | null;
    region_id: string | number;
    courier_fio: string | null;
    date_from: Date | null;
    date_until: Date | null;
};

export function initFlight(): FlightDto {
    return {
        id: '',
        code: '',
        state: '',
        courier: {
            first_name: '',
            last_name: '',
            phone_number: '',
        },
        creator: {
            first_name: '',
            last_name: '',
            username: '',
        },
        delivery_list_status: initDictItem(),
    };
}

export function fetchFlightStatuses(): Promise<DictionaryDto[]> {
    return request('/delivery-list-status').then(({ data }) => data as DictionaryDto[]);
}

export function fetchFlights(data: FlightBody): Promise<PagedView<FlightDto>> {
    return request({
        url: '/delivery-list',
        data: {
            ...data,
            date_from: data.date_from
                ? formatISO(data.date_from, { representation: 'date' })
                : null,
            date_until: data.date_until
                ? formatISO(data.date_until, { representation: 'date' })
                : null,
        },
        method: 'POST',
    }).then(({ data }) => data as PagedView<FlightDto>);
}

export function downloadFlightOrderReport(id: string | number): Promise<any> {
    return request(`/delivery-list/${id}/pdf`, {
        responseType: 'arraybuffer',
    });
}

export function downloadReturnCertificate(id: string | number): Promise<any> {
    return request(`/delivery-list/reference/${id}`, {
        responseType: 'arraybuffer',
    });
}

export function closeDeliveryList(code: string): Promise<any> {
    return request({
        url: `/delivery-list/close/${code}`,
        method: 'POST',
    }).then(({ data }) => data);
}
